module.exports = __webpack_public_path__ + "static/media/DustTestChamber.affa9ca5.jpg";